export default __webpack_public_path__ + "static/media/thumb11_report@2x.941a4f96.png";